import axios, { AxiosResponse } from 'axios';
import getBundleIdCookie from '../BundleIdCookie';
import getDeviceIdCookie from '../DeviceIdCookie';
import {
  UrpassActivateRequest,
  UrPassAgency,
  UrpassGetAgenciesRequest,
  UrpassGetProductsRequest,
  UrPassProduct,
  UrpassTicketType,
} from './types/urpassapitypes';
import handleRequests from './apiHandler';

const apiAuthHeaders = (auth: any) => {
  return {
    Authorization: `Bearer ${auth.user?.access_token}`,
    bundleID: getBundleIdCookie(),
    deviceID: getDeviceIdCookie().device_id,
    appId: 'metro',
  };
};

export const apiUrpassGetTickets = (
  auth: any,
): Promise<AxiosResponse<UrpassTicketType[], any>> => {
  return handleRequests<UrpassTicketType[]>({
    method: 'GET',
    url: process.env.REACT_APP_API_BASE + 'urpass/tickets',
    headers: apiAuthHeaders(auth),
  });
};

export const apiUrpassGetPasses = (
  auth: any,
  agency: any,
): Promise<AxiosResponse<UrPassProduct[], UrpassGetProductsRequest>> => {
  return handleRequests<UrPassProduct[]>({
    method: 'GET',
    url:
      process.env.REACT_APP_API_BASE +
      'urpass/' +
      agency.id +
      '/products/offer-tokens',
    headers: apiAuthHeaders(auth),
  });
};

export const apiUrpassGetAgencies = (
  auth: any,
): Promise<AxiosResponse<UrPassAgency[], UrpassGetAgenciesRequest>> => {
  return handleRequests<UrPassAgency[]>({
    method: 'GET',
    url: process.env.REACT_APP_API_BASE + 'urpass/tenants',
    headers: apiAuthHeaders(auth),
  });
};

export const apiUrpassPurchasePass = (
  auth: any,
  urpassTenant: string,
  paymentMethodId: number,
  offerToken: string,
): Promise<AxiosResponse<void, UrpassGetProductsRequest>> => {
  return handleRequests<void>({
    method: 'POST',
    url: process.env.REACT_APP_API_BASE + 'urpass/purchase',
    data: {
      urpassTenant,
      paymentMethodId,
      items: [
        {
          offerToken,
          quantity: 1,
        },
      ],
    },
    headers: apiAuthHeaders(auth),
  });
};

export const apiUrpassActivateTicket = (
  auth: any,
  tenantId: string,
  ticketId: string,
): Promise<AxiosResponse<UrpassTicketType, UrpassActivateRequest>> => {
  return handleRequests<UrpassTicketType>({
    method: 'PUT',
    url:
      process.env.REACT_APP_API_BASE +
      `urpass/${tenantId}/tickets/${ticketId}/activate`,
    headers: apiAuthHeaders(auth),
  });
};
